import { FC, PropsWithChildren } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { ADMIN_ROUTES } from '@/shared/constants';

import { useAdminAuth } from '@/entities/admin-session';

/**
 * Guard для закрытых маршрутов админки
 * @param root0 Пропсы
 * @param root0.children Закрытая часть приложения
 */
export const AdminProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const { isAdminLoggedIn } = useAdminAuth();

  if (!isAdminLoggedIn) {
    return (
      <Navigate to={ADMIN_ROUTES.login} state={{ from: location }} replace />
    );
  }

  return children;
};
